import { createFileRoute } from "@tanstack/react-router";
import { HomePage } from "@/features/home/HomePage";
import { HomeSearch } from "@/features/home/route-params";

export const Route = createFileRoute("/_app/home")({
  validateSearch: HomeSearch,
  component: () => <HomePage search={Route.useSearch()} />,
});
